import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpValueCategoryFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpAdditionalDataFactory } from "./ExpAdditionalData";

/**
 * A dynamic enum of groups of ExpValueTypes that the user can choose to limit the input options, such as Literal, Reference, SubExpression
 * @export
 * @interface ExpValueCategory
 */

export class ExpValueCategoryFactory {}
_ExpValueCategoryFactory = ExpValueCategoryFactory;
_defineProperty(ExpValueCategoryFactory, "FromJSON", function (json) {
  return _ExpValueCategoryFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpValueCategoryFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'id': json['id'],
    'label': json['label'],
    'selectorLabel': json['selectorLabel'],
    'description': json['description'],
    'includeInDefaultCategories': json['includeInDefaultCategories'],
    'internalOnly': json['internalOnly'],
    'excludeFromSourceInput': json['excludeFromSourceInput'],
    'additionalData': json['additionalData'] === null || json['additionalData'] === undefined ? json['additionalData'] : ExpAdditionalDataFactory.FromJSON(json['additionalData']),
    'sortPriority': json['sortPriority']
  };
});
_defineProperty(ExpValueCategoryFactory, "ToJSON", function (value) {
  return _ExpValueCategoryFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpValueCategoryFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'id': value.id,
    'label': value.label,
    'selectorLabel': value.selectorLabel,
    'description': value.description,
    'includeInDefaultCategories': value.includeInDefaultCategories,
    'internalOnly': value.internalOnly,
    'excludeFromSourceInput': value.excludeFromSourceInput,
    'additionalData': ExpAdditionalDataFactory.ToJSON(value.additionalData),
    'sortPriority': value.sortPriority
  };
});
//# sourceMappingURL=ExpValueCategory.js.map
